const MarketingModal = (() => {
  'use strict';

  class ModalStorage {
    constructor({
        localStorageKey
      }) {
      this.config = { localStorageKey };
      this.data = this._load() || {
        pageViewCount: 0,
        popUpShown: false,
      };
      console.log(this.data);
    }

    _save() {
      localStorage.setItem(this.config.localStorageKey, JSON.stringify(this.data));
    }

    _load() {
      return JSON.parse(localStorage.getItem(this.config.localStorageKey));
    }

    get(key) {
      return this.data[key];
    }

    set(key, value) {
      console.log(key, value);
      this.data[key] = value;
      this._save();
    }

    clear() {
      localStorage.removeItem(this.config.localStorageKey);
    }
  }

  class Modal {
    constructor({
        targetModal,
        restrictedPages = [],
        showDelay = 10,
        authenticated = false,
        localStorageKey = 'a708050a-6c77-405f-8a9c-cb2b431039db',
      }) {
      this.modal = targetModal;
      this.config = { restrictedPages, showDelay, authenticated };
      this.storage = new ModalStorage({localStorageKey});

      this.validate();
    }

    _increasePageCount() {
      this.storage.set('pageViewCount', this.storage.get('pageViewCount') + 1);
    }

    _visitingRestrictedPage() {
      return this.config.restrictedPages.slice().filter((restrictedPage) => {
        return restrictedPage.test(window.location.pathname);
      }).length > 0;
    }

    validate() {
      if (this.storage.get('pageViewCount') >= 1 &&
          !this.storage.get('popUpShown') &&
          !this.config.authenticated &&
          !this._visitingRestrictedPage()) {
        this.show();
      }
      this._increasePageCount();
    }

    show(noDelay = false) {
      const modal = this.modal;
      const timer = setTimeout(() => {
        console.log('Show');
        modal.style.visibility = 'visible';
        modal.style.opacity = 1;
        document.body.classList.add('modalOpen');
        this.storage.set('popUpShown', true);
      }, noDelay ? 0 : 1000 * this.config.showDelay);
    }

    close() {
      console.log(this.modal);
      this.modal.style.visibility = 'hidden';
      this.modal.style.opacity = 0;
      document.body.classList.remove('modalOpen');
    }
  }

  let activeModal = null;

  const closeModal = () => {
    activeModal.close();
  };

  const showModal = () => {
    activeModal.show(true);
  }

  const init = (targetModal, config) => {
    if (activeModal === null) {
      activeModal = new Modal({
        targetModal: document.getElementById(targetModal),
        ...config
      });

      activeModal.modal
        .querySelector('.cancel')
        .addEventListener('click', closeModal);
      activeModal.modal
        .querySelector('.close')
        .addEventListener('click', closeModal);
    }
  };

  return { init, closeModal, showModal }
})();
